/* eslint-disable import/prefer-default-export */

import { RDebitPlomberieSchema_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'
const Data = require('../json/DebitPlomberie.json')

export function fetchDebitPlomberie(uuid: string): RDebitPlomberieSchema_Type {
  return fetchGeneric<RDebitPlomberieSchema_Type>(Data, uuid)
}
